import React from 'react'
import styles from './HowWeWork.module.css'

const HowWeWork = () => {
  return (
    <div id='HowWeWork' className={styles.HowWeWork}>
      <div className={styles.HowContainer}>

        <div className={styles.PortadaSection}>
            <div className={styles.imageContainer}>
              <img 
                src={`${process.env.PUBLIC_URL}/HowWeWork.jpg`}
                alt="How QS Works - Logistics Services"
                className={styles.HowImage}
                loading="lazy"
                onError={(e) => {
                console.error('❌ Error cargando imagen HowWeWork.jpg');
                console.log('Ruta esperada:', `${process.env.PUBLIC_URL}/HowWeWork.jpg`);
                console.log('Verifica que HowWeWork.jpg esté en la carpeta public/');
                }}
                onLoad={() => {
                console.log('✅ Imagen HowWeWork.jpg cargada correctamente');
                }}
                />
                {/* Título superpuesto sobre la imagen */}
                <div className={styles.textOverlay}>
                  <h1 className={styles.PortTitle}>
                    <span className={styles.titleLine1}>How do we work?</span>
                    {/*<span className={styles.titleLine2}></span>*/}
                  </h1>
                </div>
            </div>
        </div>

        {/* Sección de Filosofía Organizacional */}
        <div className={styles.PhilosophySection}>
          
          {/* Misión */}
          <div className={styles.PhilosophyCard}>
            <div className={styles.CardHeader}>
              <div className={styles.iconWrapper}>
                <span className={styles.cardIcon}>🎯</span>
              </div>
              <h2 className={styles.CardTitle}>Misión</h2>
            </div>
            <div className={styles.CardContent}>
              <p className={styles.CardText}>
                Otorgar servicios de gestión logística cumpliendo los requisitos del 
                cliente para la generación de un flujo comercial ágil y eficiente, 
                teniendo un crecimiento óptimo y fuerza laboral sólida.
              </p>
            </div>
          </div>

          {/* Visión */}
          <div className={styles.PhilosophyCard}>
            <div className={styles.CardHeader}>
              <div className={styles.iconWrapper}>
                <span className={styles.cardIcon}>👁️</span>
              </div>
              <h2 className={styles.CardTitle}>Visión</h2>
            </div>
            <div className={styles.CardContent}>
              <p className={styles.CardText}>
                Ser una empresa competitiva manteniendo la responsabilidad social, 
                ganando participación en el sector logístico con la optimización de 
                recursos y ofreciendo a nuestros clientes alternativas y soluciones.
              </p>
            </div>
          </div>

          {/* Objetivo */}
          <div className={styles.PhilosophyCard}>
            <div className={styles.CardHeader}>
              <div className={styles.iconWrapper}>
                <span className={styles.cardIcon}>🚀</span>
              </div>
              <h2 className={styles.CardTitle}>Objetivo</h2>
            </div>
            <div className={styles.CardContent}>
              <p className={styles.CardText}>
                Conectar los mercados globales para un flujo comercial constante y de calidad.
              </p>
            </div>
          </div>

          {/* Valores */}
          <div className={styles.ValuesCard}>
            <div className={styles.CardHeader}>
              <div className={styles.iconWrapper}>
                <span className={styles.cardIcon}>🤝</span>
              </div>
              <h2 className={styles.CardTitle}>Valores</h2>
            </div>
            <div className={styles.ValuesGrid}>
              <div className={styles.ValueItem}>
                <div className={styles.valueIconWrapper}>
                  <span className={styles.valueIcon}>💎</span>
                </div>
                <h3 className={styles.ValueTitle}>Calidad</h3>
                <p className={styles.ValueText}>Compromiso con la excelencia en los servicios.</p>
              </div>
              <div className={styles.ValueItem}>
                <div className={styles.valueIconWrapper}>
                  <span className={styles.valueIcon}>💡</span>
                </div>
                <h3 className={styles.ValueTitle}>Innovación</h3>
                <p className={styles.ValueText}>Búsqueda constante de nuevas ideas y métodos.</p>
              </div>
              <div className={styles.ValueItem}>
                <div className={styles.valueIconWrapper}>
                  <span className={styles.valueIcon}>🤝</span>
                </div>
                <h3 className={styles.ValueTitle}>Lealtad</h3>
                <p className={styles.ValueText}>Creación de relaciones sólidas con clientes, empleados y socios.</p>
              </div>
              <div className={styles.ValueItem}>
                <div className={styles.valueIconWrapper}>
                  <span className={styles.valueIcon}>🎯</span>
                </div>
                <h3 className={styles.ValueTitle}>Orientación al cliente</h3>
                <p className={styles.ValueText}>Foco en la satisfacción y necesidades del cliente.</p>
              </div>
              <div className={styles.ValueItem}>
                <div className={styles.valueIconWrapper}>
                  <span className={styles.valueIcon}>🤲</span>
                </div>
                <h3 className={styles.ValueTitle}>Respeto</h3>
                <p className={styles.ValueText}>Valorar la diversidad y la inclusión.</p>
              </div>
              <div className={styles.ValueItem}>
                <div className={styles.valueIconWrapper}>
                  <span className={styles.valueIcon}>✅</span>
                </div>
                <h3 className={styles.ValueTitle}>Responsabilidad</h3>
                <p className={styles.ValueText}>Cumplir con las obligaciones y compromisos.</p>
              </div>
              <div className={styles.ValueItem}>
                <div className={styles.valueIconWrapper}>
                  <span className={styles.valueIcon}>🌱</span>
                </div>
                <h3 className={styles.ValueTitle}>Responsabilidad social</h3>
                <p className={styles.ValueText}>Compromiso con el bienestar de la comunidad y el medio ambiente.</p>
              </div>
              <div className={styles.ValueItem}>
                <div className={styles.valueIconWrapper}>
                  <span className={styles.valueIcon}>👥</span>
                </div>
                <h3 className={styles.ValueTitle}>Trabajo en equipo</h3>
                <p className={styles.ValueText}>Colaboración para lograr objetivos comunes.</p>
              </div>
            </div>
          </div>

        </div>

      </div>
      
    </div> 
  )
}

export default HowWeWork